type ValueOf<T> = T[keyof T];

const subscribeEvents = {
  IN_APP_MESSAGE: 'inAppMessage',
  CONTENT_CARDS: 'contentCards',
} as const;

type SubscribeEvent = ValueOf<typeof subscribeEvents>;

const publishEvents = {
  SET_CUSTOM_USER_ATTRIBUTE: 'setCustomUserAttribute',
  SEND_CUSTOM_EVENT: 'sendCustomEvent',
  IN_APP_MESSAGE_SHOWN: 'inAppMessage.shown',
  IN_APP_MESSAGE_CLICKED: 'inAppMessage.clicked',
  IN_APP_MESSAGE_BUTTON_CLICKED: 'inAppMessageButton.clicked',
  IN_APP_MESSAGE_HTML_CLICKED: 'inAppMessageHTML.clicked',
  CONTENT_CARD_SHOWN: 'contentCard.shown',
  CONTENT_CARD_CLICKED: 'contentCard.clicked',
} as const;

type PublishEvent = ValueOf<typeof publishEvents>;

export { subscribeEvents, SubscribeEvent, publishEvents, PublishEvent };
